import type { ResolvedRunsSummaryTimeframe } from "./runsSummaryTypes"

export function formatCount(value: number): string {
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
    value,
  )
}

export function pluralize(
  count: number,
  singular: string,
  plural = `${singular}s`,
): string {
  return count === 1 ? singular : plural
}

export function formatRate(rate: number | null): string {
  if (rate === null) {
    return "n/a"
  }
  return `${Math.round(rate * 100)}%`
}

export function formatDeltaPoints(delta: number): string {
  return `${Math.round(Math.abs(delta * 100))} pts`
}

export function formatPercent(value: number): string {
  return `${Math.round(value * 100)}%`
}

export function formatMetricNumber(value: number): string {
  const absValue = Math.abs(value)
  if (absValue >= 100 || Number.isInteger(value)) {
    return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
      value,
    )
  }
  if (absValue >= 10) {
    return new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 1,
    }).format(value)
  }
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  }).format(value)
}

export function getRunsSummaryTimeframeLabel(
  timeframe: ResolvedRunsSummaryTimeframe,
): string {
  switch (timeframe) {
    case "24h":
      return "Last 24 hours"
    case "7d":
      return "Last 7 days"
    case "30d":
      return "Last 30 days"
  }
}

export function getPreviousTimeframeLabel(
  timeframe: ResolvedRunsSummaryTimeframe,
): string {
  switch (timeframe) {
    case "24h":
      return "prior 24 hours"
    case "7d":
      return "prior 7 days"
    case "30d":
      return "prior 30 days"
  }
}

export function average(values: number[]): number | null {
  if (values.length === 0) {
    return null
  }
  return values.reduce((sum, value) => sum + value, 0) / values.length
}
